import React from "react";
import { FaBuilding, FaCheckCircle } from "react-icons/fa";
import "./InstitutePicker.scss";

/**
 * InstitutePicker — modal overlay shown when a user belongs to multiple active institutes.
 *
 * Props:
 *   institutes  — array of { instituteId, instituteName, instituteCode, subdomain, status }
 *   onSelect    — callback(institute) when user picks one
 *   onCancel    — callback when user dismisses
 *   loading     — boolean, disables buttons while re-submitting
 *   title       — optional heading override
 */
const InstitutePicker = ({ institutes = [], onSelect, onCancel, loading, title }) => {
  if (!institutes.length) return null;

  return (
    <div className="ip-overlay" onClick={onCancel}>
      <div className="ip-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ip-header">
          <FaBuilding className="ip-header-icon" />
          <h3>{title || "Choose Your Institute"}</h3>
          <p>You are associated with multiple institutes. Please select one to continue.</p>
        </div>

        <div className="ip-list">
          {institutes.map((inst) => (
            <button
              key={inst.instituteId}
              className="ip-card"
              disabled={loading}
              onClick={() => onSelect(inst)}
            >
              <div className="ip-card-info">
                <span className="ip-card-name">{inst.instituteName}</span>
                {inst.instituteCode && (
                  <span className="ip-card-code">Code: {inst.instituteCode}</span>
                )}
                {inst.status === "trial" && (
                  <span className="ip-card-badge ip-badge-trial">Trial</span>
                )}
                {inst.status === "active" && (
                  <span className="ip-card-badge ip-badge-active">Active</span>
                )}
              </div>
              <FaCheckCircle className="ip-card-arrow" />
            </button>
          ))}
        </div>

        <button className="ip-cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default InstitutePicker;
